<script lang="ts">
    import { derived as sderived } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import { simpleImageAlts } from 'hydria/attachment_helpers'
    import type { HydriaDocument, IImage } from 'hydria/HydriaDocument'
    import { type TGettext, gettext as _ } from 'hydria/services/gettext'

    import HtmlField from '../../BaseFields/HtmlField.svelte'

    interface Props {
        disabled: boolean
        isValid?: (v: string | undefined) => boolean
        styles: string[]
        value: string
        saved: string | undefined
        label: TGettext
        cssStyles?: string | undefined
        helpText?: TGettext | undefined
        backgroundImageUrl?: string | undefined
        Document: HydriaDocument

        setValue: (v: string | undefined) => void
    }

    let { disabled, isValid = (v) => v != null && v.trim() != null, styles, value, saved, label, cssStyles = undefined, helpText = undefined, backgroundImageUrl = undefined, Document, setValue }: Props = $props()

    const images = sderived(Document.attachedImages, ($atts) => $atts)

    let full = $state(false)
    let editHtml = $state(false)

    let htmlElement: HTMLElement | undefined = $state()
    let elementHeight: number = $derived.by(() => {
        saved
        value
        htmlElement
        styles
        return htmlElement ? htmlElement.getBoundingClientRect().height : 0
    })

    // $effect(() => {
    //     if (saved || value || htmlElement || styles)
    //         tick().then(() => {
    //             loadSize()
    //         })
    // })

    let bgImagePos = $derived(styles.filter((s) => s.startsWith('bg-img-'))[0])

    function cleanImages(html: string, attachedImages: IImage[]) {
        const parser = new DOMParser()
        const dom = parser.parseFromString(html, 'text/html')

        const attImgs = Array.from(dom.querySelectorAll('img[aid]'))
        for (const attImg of <Array<HTMLImageElement>>attImgs) {
            const aid = attImg.getAttribute('aid')
            const image = attachedImages.filter((o) => o.id === aid)[0]
            if (image && image['mimetype'].startsWith('image/')) {
                // Convert <img> into a <picture>
                const alts = simpleImageAlts(image as IImage, false)

                const picture = document.createElement('picture')
                const src = document.createElement('source')
                src.setAttribute('srcset', alts.map((o) => `${o.url.replace(/,/, '%2C')} ${o.width}w`).join(', '))
                src.setAttribute('sizes', '30vw')
                picture.appendChild(src)
                const img = document.createElement('img')
                for (const attr of Array.from(attImg.attributes)) {
                    img.setAttribute(attr.name, attr.value)
                }
                picture.appendChild(img)
                attImg.replaceWith(picture)
            }
        }

        return dom.body.innerHTML
    }
</script>

<div class="schemed-html-bloc" class:full={full || elementHeight <= 256} class:partial={!full && elementHeight > 256}>
    <div class="controls">
        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary" onclick={() => (editHtml = true)} {disabled}><Icon inline icon="mdi:pencil" /></button>
            <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => (full = !full)} class:active={full} disabled={elementHeight <= 256}><Icon inline icon="mdi:arrow-up-down" /></button>
        </div>
    </div>

    <div class="bg-fade-out"></div>
    <div class="section-simple-html outer scheme section {styles.join(' ')}" style={cssStyles} class:has-bg-img={backgroundImageUrl && !bgImagePos} class:has-image={backgroundImageUrl && bgImagePos} bind:this={htmlElement}>
        <div class="inner">
            {#if backgroundImageUrl && !bgImagePos}
                <div class="bg"><img src={backgroundImageUrl} alt="" /></div>
            {/if}
            <div class="content" class:container-fluid={bgImagePos} class:container-xl={!bgImagePos}>
                <div class="row">
                    {#if bgImagePos}
                        <div class="col-12 col-md-4 col-lg-5 position-relative bg-img-col" class:order-last={bgImagePos == 'bg-img-end'}>
                            <div class="bg"><img src={backgroundImageUrl} alt="" /></div>
                        </div>
                    {/if}
                    <section class="col html-content">
                        {#if value != null && value != ''}
                            <div
                                aria-hidden="true"
                                class="has-content"
                                ondblclick={() => {
                                    if (!disabled) editHtml = true
                                }}
                            >
                                {@html cleanImages(value, $images)}
                            </div>
                        {:else}
                            <div
                                aria-hidden="true"
                                class="no-content"
                                ondblclick={() => {
                                    if (!disabled) editHtml = true
                                }}
                            >
                                <div>{$_('Aucun texte')}</div>
                            </div>
                        {/if}
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

{#if editHtml}
    <HtmlField
        {value}
        {saved}
        {label}
        {helpText}
        {isValid}
        {Document}
        close={() => (editHtml = false)}
        save={(e) => {
            setValue(e)
            editHtml = false
        }}
    />
{/if}
